
class cvData
{
    constructor() {
        this.AddNewElementToRawData = this.AddNewElementToRawData.bind(this);
    }
    
AddNewElementToRawData(type, name, surname, age)
{
    this.rawData.project.push(
    {
        type: type,
        name: name,
        surname: surname,
        age : age,
        height: 400
    });
    console.log("Ence pence", this.rawData.project);
}

ChangeElementInRawData(index,type, name, surname, age)
{
    this.rawData.project[index] = (
    {
        type: type,
        name: name,
        surname: surname,
        age : age,
        height: 400
    });
    console.log("Ence pence", this.rawData.project);
}


}


export default cvData